import Enemy, { randomInt } from "../enemy.js";
import { EnemyConfig, EnemyStateConfig } from "../../GameConfig/EnemyConfig.js";
import { Fly, Death } from "../states/index.js";

export default class ShipFighter extends Enemy {
    constructor() {
        super();

        this.name = "ShipFighter";

        this.states = [
            new Fly(
                this,
                EnemyConfig.ShipFighter.IMG_SRC_FLY,
                EnemyConfig.ShipFighter.MAX_FRAME_FLY,
            ),
            new Death(
                this,
                EnemyConfig.ShipFighter.IMG_SRC_DEATH,
                EnemyConfig.ShipFighter.MAX_FRAME_DEATH,
            ),
        ];
        this.currentState = this.states[EnemyStateConfig.FLY];

        this.y = randomInt(
            EnemyConfig.ShipFighter.MIN_Y_POS,
            EnemyConfig.ShipFighter.MAX_Y_POS,
        );

        this.image.src = EnemyConfig.ShipFighter.IMG_SRC_FLY;

        this.spriteWidth = EnemyConfig.ShipFighter.SPRITE_WIDTH;
        this.spriteHeight = EnemyConfig.ShipFighter.SPRITE_HEIGHT;

        this.speed = randomInt(
            EnemyConfig.ShipFighter.MIN_SPEED,
            EnemyConfig.ShipFighter.MAX_SPEED,
        );

        this.health = EnemyConfig.ShipFighter.HEALTH;
        this.score = EnemyConfig.ShipFighter.ENEMY_SCORE;
        this.damage = EnemyConfig.ShipFighter.ENEMY_DAMAGE;

        this.canAttack = EnemyConfig.ShipFighter.CAN_ATTACK;

        this.rarity = EnemyConfig.ShipFighter.RARITY;
    }
}
